import * as React from 'react';
import { useGetAccountingUserQuery } from "../../../apis/AccountingUser.api";
import { PrimaryAccountingUser, AccountingUser } from "../../../types/models/AccountingUser";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: AccountingUser;
};

export const AccountingUserNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.email }
                    {data?.name && <> | </> }{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const AccountingUserName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetAccountingUserQuery(PrimaryAccountingUser.fromId(id))
    return (<AccountingUserNameDisplay data={data}/>)
}

export default AccountingUserName;
